<template>
  <div>
    <check-selector-collapse
      :icon="icon"
      :label="label"
      :options="tiposOpciones"
      @checked="handleChecked"
    />
  </div>
</template>

<script>
import CheckSelectorCollapse from '../../../../commons/forms/CheckSelectorCollapse.vue';
import catalogoSellout from '@/api/catalogoSellout.api';
import { mapActions } from 'vuex';
import { mapState } from 'vuex';

export default {
  name: 'TipoSelector',
  components: { CheckSelectorCollapse },
  extends: catalogoSellout,
  props: {
    label: {
      type: String,
      default: 'Tipos de descuento',
    },
    icon: {
      type: String,
      default: 'icon-pharmacy',
    },
  },
  data() {
    return {
      tiposOpciones: [
        { text: 'Farmacia (F)', value: 'F' },
        { text: 'Categoría (C)', value: 'C' },
        { text: 'Producto (P)', value: 'P' },
      ],
      selectedItems: [],
      selectedItemsSet: new Set(),
    };
  },
  computed: {
    ...mapState('filters', ['filtros']),
  },
  watch: {
    'filtros.tipos': function (newFiltros) {
      this.syncSelectedItemsWithStore(newFiltros);
    },
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      let loadPromise = new Promise((resolve) => {
        this.getTiposArticulos(resolve, this.request);
      });

      loadPromise.then((data) => {
        this.options = data.map((item) => ({
          text: item.tipo_articulo_desc,
          value: item.tipo_articulo_codigo,
          selected: false,
        }));
      });
    },
    syncSelectedItemsWithStore() {
      const tiposSeleccionados = this.filtros.tipos || [];

      const selectedItemsSet = new Set();

      tiposSeleccionados.forEach((tipo) => {
        selectedItemsSet.add(String(tipo.codigo));
        selectedItemsSet.add(String(tipo.value));
      });

      this.tiposOpciones = this.tiposOpciones.map((item) => {
        item.selected = selectedItemsSet.has(String(item.value));
        return item;
      });
    },
    handleChecked(newSelectedItems) {
      const tiposSeleccionados = this.filtros.tipos || [];

      if (!Array.isArray(newSelectedItems)) {
        newSelectedItems = [newSelectedItems];
      }

      newSelectedItems.forEach((selected) => {
        const valueToCheck = String(selected.value);

        if (selected.selected) {
          this.selectedItemsSet.add(valueToCheck);
        } else {
          this.selectedItemsSet.delete(valueToCheck);
        }
      });

      let selectedItemsArray = Array.from(this.selectedItemsSet);

      tiposSeleccionados.forEach((item) => {
        const valueToCheck = item.value
          ? String(item.value)
          : String(item.codigo);

        if (!selectedItemsArray.includes(valueToCheck)) {
          selectedItemsArray.push(valueToCheck);
        }
      });

      newSelectedItems.forEach((selected) => {
        if (!selected.selected) {
          const valueToCheck = String(selected.value);
          selectedItemsArray = selectedItemsArray.filter(
            (item) => item !== valueToCheck
          );
        }
      });

      const selectedItems = newSelectedItems.map((item) => item.value);
      this.updateFiltros({
        filtro: 'tip',
        items: selectedItems,
      });
      console.log(newSelectedItems);
      // this.$emit('update_filters', newSelectedItems);
      this.emitSelectedItems();
    },

    emitSelectedItems() {
      const selectedItemsArray = Array.from(this.selectedItemsSet);
      this.$emit('update_filters', selectedItemsArray);
    },
    ...mapActions('filters', ['updateFiltros']),
  },
};
</script>
